import React from "react";
import PropTypes from "prop-types";
import { ListGroup, ListGroupItem } from "reactstrap";
import { AUTOMATION_CATEGORIES } from "../../../../models/automation";
import { NeoSideMenu, NeoBadge } from "../../../../components/Common";

/**
 * AutomationSidebar
 * Sidebar com as categorias de automação utilizando o NeoSideMenu do Neo Design System.
 */
const AutomationSidebar = ({ triggers = [], activeCategoryId, onSelectCategory, loading }) => {

    // Contar ativos por categoria
    const countByCategory = {};
    const totalByCategory = {};
    AUTOMATION_CATEGORIES.forEach(cat => {
        countByCategory[cat.id] = 0;
        totalByCategory[cat.id] = 0;
    });
    triggers.forEach(t => {
        if (totalByCategory[t.category] !== undefined) totalByCategory[t.category]++;
        if (t.active && countByCategory[t.category] !== undefined) countByCategory[t.category]++;
    });

    const activeTotal = triggers.filter(t => t.active).length;

    return (
        <NeoSideMenu
            title="Automações"
            subtitle={`${activeTotal} de ${triggers.length} ativas`}
            icon="mdi-robot-outline"
            loading={loading}
        >
            <ListGroup flush>
                {AUTOMATION_CATEGORIES.map((cat) => {
                    const isActive = activeCategoryId === cat.id;
                    const activeCount = countByCategory[cat.id];
                    const total = totalByCategory[cat.id];

                    return (
                        <div className="px-2 mb-1.5" key={cat.id}>
                            <ListGroupItem
                                tag="button"
                                action
                                onClick={() => onSelectCategory(cat.id)}
                                className={`border-0 py-3 px-3 d-flex align-items-center justify-content-between select-none neo-side-menu-item ${isActive ? "neo-side-menu-item--active" : ""}`}
                            >
                                <div className="d-flex align-items-center flex-grow-1 overflow-hidden">
                                    <div className="side-menu-icon-wrapper me-3 flex-shrink-0">
                                        <i className={`mdi ${cat.icon} font-size-16`} />
                                    </div>
                                    <div className="text-start overflow-hidden">
                                        <h6 className="mb-0 fw-bold text-truncate font-size-13 side-menu-title">
                                            {cat.id}
                                        </h6>
                                        <span className="text-muted small font-size-11 d-block text-truncate">
                                            {total} gatilho{total !== 1 ? 's' : ''}
                                        </span>
                                    </div>
                                </div>

                                {activeCount > 0 && (
                                    <div className="flex-shrink-0 ms-2">
                                        <NeoBadge color="success">
                                            {activeCount} ativa{activeCount !== 1 ? 's' : ''}
                                        </NeoBadge>
                                    </div>
                                )}
                            </ListGroupItem>
                        </div>
                    );
                })}
            </ListGroup>
        </NeoSideMenu>
    );
};

AutomationSidebar.propTypes = {
    triggers: PropTypes.array,
    activeCategoryId: PropTypes.string,
    onSelectCategory: PropTypes.func.isRequired,
    loading: PropTypes.bool,
};

export default AutomationSidebar;
